import { render, staticRenderFns } from "./communication-summary.vue?vue&type=template&id=5c98f1f1"
import script from "./communication-summary.vue?vue&type=script&lang=js"
export * from "./communication-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports